// Types de documents hérités de l'ancien système (utilisés pour l'affichage
// des « documents récents » sur l'accueil de l'espace client).
export const DOC_TYPES = [
  ["devis", "Devis"], ["presentation", "Présentation de projet"], ["cahier", "Cahier des charges"],
  ["administratif", "Document administratif"], ["autre", "Autre document"],
];
export const docTypeLabel = (t) => (DOC_TYPES.find(([id]) => id === t) || DOC_TYPES[4])[1];
